import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=2d4a15de"
import script from "./VSelect.vue?vue&type=script&lang=ts"
export * from "./VSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports